export const getShapeCoordinate = (
  lineAlignment,
  currentShape,
  canvasTop,
  canvasLeft,
  canvasRight,
  canvasBottom,
  setLinePos
) => {
  let points;

  if (currentShape === "simple") {
    points = [0, 0, canvasTop, 0, canvasTop, canvasLeft, 0, canvasLeft, 0, 0];

    if (lineAlignment === "split" || lineAlignment === "vertical") {
      setLinePos([canvasBottom, 0, canvasBottom, canvasLeft]);
    } else {
      setLinePos([canvasRight, 0, canvasRight, canvasLeft]);
    }
  } else if (currentShape === "left") {
    points = [
      0,
      0,
      canvasTop,
      0,
      canvasTop,
      canvasRight,
      canvasBottom,
      canvasRight,
      canvasBottom,
      canvasLeft,
      0,
      canvasLeft,
      0,
      0,
    ];

    if (lineAlignment === "vertical" || lineAlignment === "split") {
      setLinePos([canvasBottom, 0, canvasBottom, canvasRight]);
    }
    if (lineAlignment === "horizontal") {
      setLinePos([0, canvasRight, canvasBottom, canvasRight]);
    }
  } else {
    points = [
      0,
      0,
      canvasTop,
      0,
      canvasTop,
      canvasRight,
      canvasBottom,
      canvasRight,
      canvasBottom,
      canvasLeft,
      0,
      canvasLeft,
      0,
      0,
    ];
    if (lineAlignment === "vertical" || lineAlignment === "split") {
      setLinePos([canvasBottom, 0, canvasBottom, canvasLeft]);
    }
    if (lineAlignment === "horizontal") {
      setLinePos([canvasTop, canvasLeft, canvasBottom, canvasLeft]);
    }
  }

  return points;
};
